"use client";

import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { FadeInUp } from "@/components/ui/motion";

const topQuestions = [
  {
    q: "Do I need coding experience?",
    a: "No coding required! Our visual builder lets you create powerful automations by connecting blocks. However, developers can add custom code blocks for advanced logic.",
  },
  {
    q: "What counts as a workflow run?",
    a: "A workflow run is counted each time your workflow executes from trigger to completion. Retries within a run don't count as additional runs.",
  },
  {
    q: "Is there a free tier?",
    a: "Yes! We offer a generous free tier with 1,000 runs/month-no credit card required. Use it as long as you need.",
  },
  {
    q: "How do you handle failures?",
    a: "Automatic retries with exponential backoff, dead-letter queues for failed runs, and full execution replay for debugging.",
  },
];

export function FAQTeaser() {
  const router = useRouter();

  return (
    <section
      id="faq"
      className="py-20 lg:py-28 section-elevated relative overflow-hidden"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <FadeInUp className="max-w-2xl mx-auto text-center mb-12">
          <h2 className="text-foreground mb-4 tracking-tight">
            Common questions
          </h2>
          <p className="text-lg text-muted-foreground/90">
            Quick answers to help you get started.
          </p>
        </FadeInUp>

        <FadeInUp delay={0.1} className="max-w-2xl mx-auto mb-10">
          <Accordion type="single" collapsible className="space-y-3">
            {topQuestions.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-xl px-6 data-[state=open]:border-primary/40 data-[state=open]:shadow-md data-[state=open]:shadow-primary/5 transition-all duration-200"
              >
                <AccordionTrigger className="text-left hover:no-underline py-5 group">
                  <span className="font-medium text-foreground group-hover:text-primary transition-colors">
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground/90 pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeInUp>

        <FadeInUp delay={0.2} className="text-center">
          <Button
            variant="ghost"
            onClick={() => router.push("/faq")}
            className="text-primary"
          >
            View all FAQs
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </FadeInUp>
      </div>
    </section>
  );
}
